import React, { Fragment } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
interface BreadcrumbItem {
  label: {
    en: string;
    ar: string;
  };
  href: string;
}
interface SitemapProps {
  currentPage: {
    en: string;
    ar: string;
  };
  breadcrumbs: BreadcrumbItem[];
}
export function Sitemap({
  currentPage,
  breadcrumbs
}: SitemapProps) {
  const {
    isArabic
  } = useLanguage();
  return <nav className="mb-8" data-id="element-1376">
      <ol className="flex flex-wrap items-center gap-2 text-sm text-gray-500 dark:text-gray-400" data-id="element-1377">
        <li data-id="element-1378">
          <Link to="/" className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors" data-id="element-1379">
            {isArabic ? 'الرئيسية' : 'Home'}
          </Link>
        </li>
        <li data-id="element-1380">
          <ChevronRightIcon className="w-4 h-4" data-id="element-1381" />
        </li>
        {breadcrumbs.map((item, index) => <Fragment key={index} data-id="element-1382">
            <li data-id="element-1383">
              <Link to={item.href} className="hover:text-blue-600 dark:hover:text-blue-400 transition-colors" data-id="element-1384">
                {isArabic ? item.label.ar : item.label.en}
              </Link>
            </li>
            <li data-id="element-1385">
              <ChevronRightIcon className="w-4 h-4" data-id="element-1386" />
            </li>
          </Fragment>)}
        <li className="font-medium text-gray-900 dark:text-white" data-id="element-1387">
          {isArabic ? currentPage.ar : currentPage.en}
        </li>
      </ol>
    </nav>;
}